<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Юридическая информация</span>
        <h1 class="page-hero__title">Условия использования</h1>
        <p class="page-hero__text">Правила работы с сервисом CandB.pro для всех пользователей</p>
      </div>
    </div>

    <section class="section">
      <div class="container legal-content">
        <p class="legal-meta">Редакция от 26 августа 2026 г.</p>

        <h2>1. Предмет соглашения</h2>
        <p>
          Настоящие Условия использования регулируют отношения между ООО «Степ М» (далее — «Оператор»)
          и пользователем сервиса <strong>CandB.pro</strong>, размещённого на сайте
          <a href="https://candb.pro">candb.pro</a> (далее — «Сервис»).
        </p>
        <p>
          Регистрация и использование Сервиса означают полное и безоговорочное принятие
          настоящих Условий пользователем.
        </p>

        <h2>2. Описание Сервиса</h2>
        <p>
          CandB.pro — облачный сервис автоматизации расчёта премий, KPI и мотивационных составляющих
          дохода сотрудников. Сервис предоставляется по модели SaaS на условиях ежемесячной
          или ежегодной подписки в соответствии с действующим тарифным планом.
        </p>

        <h2>3. Регистрация и учётная запись</h2>
        <ul>
          <li>Регистрация осуществляется по номеру мобильного телефона с подтверждением через одноразовый код в Telegram.</li>
          <li>Пользователь обязан указывать достоверные данные и поддерживать их в актуальном состоянии.</li>
          <li>Пользователь несёт полную ответственность за сохранность учётных данных и любые действия, совершённые с его учётной записи.</li>
          <li>При компрометации учётной записи пользователь обязан незамедлительно уведомить Оператора.</li>
        </ul>

        <h2>4. Права и обязанности сторон</h2>
        <h3>Оператор обязуется:</h3>
        <ul>
          <li>обеспечивать круглосуточную доступность Сервиса согласно SLA выбранного тарифа;</li>
          <li>защищать данные пользователя в соответствии с Политикой конфиденциальности;</li>
          <li>уведомлять о существенных изменениях в работе Сервиса не менее чем за 14 дней.</li>
        </ul>
        <h3>Пользователь обязуется:</h3>
        <ul>
          <li>использовать Сервис только в законных целях;</li>
          <li>не предпринимать попыток обхода систем безопасности;</li>
          <li>своевременно оплачивать выбранный тариф;</li>
          <li>не передавать доступ третьим лицам без согласия Оператора.</li>
        </ul>

        <h2>5. Пробный период</h2>
        <p>
          Оператор предоставляет 14 (четырнадцать) календарных дней бесплатного доступа ко всем функциям
          тарифа «Бизнес» без необходимости указывать платёжные данные. По истечении пробного периода
          доступ автоматически прекращается, если пользователь не выберет платный тариф.
        </p>

        <h2>6. Оплата и тарифы</h2>
        <ul>
          <li>Оплата производится ежемесячно или ежегодно по выставленному счёту.</li>
          <li>При оплате за год предоставляется скидка 20% от ежемесячной стоимости.</li>
          <li>Цены указаны без НДС. НДС начисляется в установленном законом порядке.</li>
          <li>Возврат оплаты за неиспользованный период производится по согласованию сторон.</li>
        </ul>

        <h2>7. Ограничение ответственности</h2>
        <p>
          Оператор не несёт ответственности за косвенные убытки, упущенную выгоду
          и нематериальный ущерб, возникшие в результате использования или невозможности
          использования Сервиса. Совокупная ответственность Оператора по любым основаниям
          ограничена суммой, оплаченной пользователем за последние 12 месяцев.
        </p>

        <h2>8. Интеллектуальная собственность</h2>
        <p>
          Все права на программное обеспечение Сервиса, дизайн, тексты и иные материалы
          принадлежат Оператору. Пользователь получает простую (неисключительную) лицензию
          на использование Сервиса на срок и условиях выбранного тарифа.
        </p>

        <h2>9. Расторжение</h2>
        <p>
          Пользователь вправе прекратить использование Сервиса в любой момент через личный кабинет.
          Оператор вправе ограничить доступ при нарушении настоящих Условий — с предварительным
          уведомлением, за исключением случаев грубых нарушений.
        </p>

        <h2>10. Применимое право</h2>
        <p>
          Настоящие Условия регулируются правом Российской Федерации. Все споры подлежат
          разрешению в соответствии с действующим законодательством РФ.
        </p>

        <h2>11. Контакты</h2>
        <p>
          По вопросам использования Сервиса обращайтесь:
          <br><a href="mailto:info@candb.pro">info@candb.pro</a> — общие вопросы и техническая поддержка.
          <br><a href="tel:+79939037308">+7 993 903-73-08</a>
        </p>
        <p class="legal-req">
          <strong>Реквизиты Оператора</strong><br>
          Общество с ограниченной ответственностью «Степ Менеджмент» (ООО «Степ М»)<br>
          ИНН 5040202027, КПП 504001001, ОГРН 1265000059500<br>
          Адрес: 140120, Московская область, Раменский м.о., пгт. Ильинский, ул. Чкалова, д. 2, кв. 33
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default { name: 'TermsPage' }
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title { font-size: 2.5rem; font-weight: 800; margin: 12px 0 16px; }
.page-hero__text { font-size: 1.125rem; opacity: 0.85; max-width: 620px; }

.legal-content { max-width: 780px; }
.legal-meta { color: var(--gray); font-size: 0.875rem; margin-bottom: 32px; }
.legal-req {
  background: var(--bg-soft, #f5f7fa);
  border-left: 3px solid var(--primary);
  border-radius: 8px;
  padding: 16px 18px;
  font-size: 0.9375rem;
  line-height: 1.7;
}

.legal-content h2 {
  font-size: 1.375rem; font-weight: 700; margin: 32px 0 12px; color: var(--dark);
}
.legal-content h3 {
  font-size: 1.0625rem; font-weight: 600; margin: 20px 0 8px; color: var(--dark);
}
.legal-content p, .legal-content li {
  color: var(--gray); line-height: 1.7; font-size: 1rem; margin-bottom: 12px;
}
.legal-content ul { padding-left: 22px; margin-bottom: 16px; }
.legal-content a { color: var(--primary); text-decoration: none; }
.legal-content a:hover { text-decoration: underline; }

@media (max-width: 768px) {
  .page-hero__title { font-size: 1.875rem; }
}
</style>
